"use client";

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyCouplesChooseABStudios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const testimonials = [{
    name: "Emily & James",
    heading: "You're The Centre Of The Day",
    quote: "This is your wedding, not a photo shoot.\nOur approach is designed so the attention stays where it belongs, on you. We don't interrupt moments, pull you away from guests, or turn your day into a schedule of poses. You get to move, laugh, cry, and celebrate freely, knowing every meaningful moment is being captured quietly and intentionally.\n"
  }, {
    name: "Sophie & Mark",
    heading: "Calm, Not Chaos",
    quote: "\"A wedding day should feel memorable, not overwhelming.\nWe bring structure without pressure and guidance without control. From morning preparations through to the final dance, we help the day flow naturally so you never feel rushed or scattered. No constant instructions, no clock-watching, no tension.\n"
  }, {
    name: "Rachel & David",
    heading: "Memories You Can Trust",
    quote: "\"What you remember matters, and how it's captured matters even more. What we capture reflects who you are and how the day truly felt.\nWhen you watch your wedding film or look through your photos years from now, you won't just see it, you'll feel it again. That's what great wedding photography and videography in Sydney should do.\""
  }];
  return <section ref={ref} className={`
        relative py-20 md:py-28 bg-light-background transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
      `}>
      <div className="container mx-auto px-6 max-w-6xl">
        <h2 className="font-display text-4xl md:text-5xl text-center mb-4 text-foreground-light">
          Why Couples Choose AB Studios
        </h2>
        <p className="text-center text-foreground-light/70 mb-12 max-w-2xl mx-auto">
          The three Top Reasons couples trust us to capture their special day
        </p>

        <div className="flex justify-center items-center mb-12">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_m13y7oqu.jpg" alt="AB Studios Wedding Photography" className="w-full max-w-2xl rounded-lg shadow-medium object-cover" />
        </div>

        <div className="relative px-12">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2 lg:basis-1/3">
                  <Card className="h-full hover:scale-[1.02] transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] shadow-soft hover:shadow-medium">
                    <CardContent className="p-8 flex flex-col items-center text-center gap-6">
                      <h3 className="font-display text-xl font-semibold text-foreground-light mb-2">
                        {testimonial.heading}
                      </h3>
                      <p className="text-foreground-light italic leading-relaxed">
                        "{testimonial.quote}"
                      </p>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-fast)]" />
            <CarouselNext className="opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-fast)]" />
          </Carousel>
        </div>
      </div>
    </section>;
}